<template>
  <div>
    <table-temp
      v-if="!isBackShow"
      title
      :flag="1"
      :tableData="tableData"
      :columnData="tableConf"
      :isBackShow="isBackShow"
      :isLookShow="isLookShow"
      :showSummary="true"
      :summaryMethod="getSummaries"
      @editTable="editTable"
      @lookDetail="lookDetail"
      @handleSelectionChange="handleSelectionChange"
    >
      <div slot="tool">
        <el-button class="borderBtn" @click="addDialog">添加</el-button>
        <el-button class="borderBtn" @click="delProduct">删除</el-button>
      </div>
    </table-temp>
    <step-dialog
      :dialogVisible="dialogVisible"
      :title="title"
      @closeDialog="closeDialog"
      @reload="reloadData"
      :data="commonData"
      :codeId="codeId"
      @inputChange="inputChange"
      :key="key"
    ></step-dialog>
    <div class="footerBtn">
      <el-button @click="pre">上一步</el-button>
      <el-button class="mainBtn" @click="save">保存</el-button>
      <el-button class="mainBtn" @click="next">保存并下一步</el-button>
    </div>
  </div>
</template>

<script>
import TableTemp from '../table4xStep23'
import { step2, step5, step2Agency } from '@/conf/Report-manager'
import StepDialog from '../dialog/step2Dialog'
import comMixin from 'common/js/mixin/comMixin'

import { mapState, mapMutations } from 'vuex'
import {
  getReportDetail,
  getFund,
  delFund,
  getProduct,
  delProduct,
  nation,
  selectDic,
  deleteMgrProduct,
  deleteFundInvested,
  getReportMgrProductByReportCode,
  getReportFundInvestedByReportCode
} from 'common/js/api'

export default {
  components: {
    TableTemp,
    StepDialog
  },

  mixins: [comMixin],

  data() {
    return {
      title: '添加机构',
      tableData: [],
      tableConf: [],
      dialogVisible: false,
      isManager: true,
      codeId: this.$route.query.codeId,
      commonData: {},
      selectIds: '',
      step: 1,
      isBackShow: false,
      fundId: '',
      dialogVisible1: false,
      selectIds1: '',
      isLookShow: false,
      provinceList: [],
      cityList: [],
      key: 0
    }
  },

  created() {
    // 设置配环境
    this.setEnvironment()
  },

  mounted() {
    this.setConf()
    // 查询vuex数据
    // this.setData();
    this.getProductListData()
    this.getSelect()
    this.getNation()
  },

  methods: {
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => {
          if (column.property === 'admittedCapital') {
            return Number(item[column.property])
          } else if (column.property === 'paidCapital') {
            return Number(item[column.property])
          } else if (column.property === 'capitalInvested') {
            return Number(item[column.property])
          }
        })
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2) + ''
        } else {
          sums[index] = ''
        }
      })

      return sums
    },
    //获取基金已发行产品情况
    async getProductListData() {
      console.log('getReportMgrProductByReportCode!!@@')
      const params = {
        reportCode: this.codeId
      }
      if (this.isManager) {
        const res = await getReportMgrProductByReportCode(params)
        console.log('getReportMgrProductByReportCode', res)
        this.tableData = res.result.filter(item => {
          console.log('@@---->', item)
          return item.productType == 1
        })
      } else {
        const res = await getReportFundInvestedByReportCode(params)
        console.log('getReportFundInvestedByReportCode', res)
        // this.tableData = res.result;
        let tableData = res.result.filter(item => {
          console.log('@@->', item)
          return item.investedType == 1
        })
        tableData.forEach((element, index) => {
          let obj = {}
          if (element.extraInfo) {
            console.log('extraInfo')
            let a = element.extraInfo
            // this.$delete(element, 'extraInfo')
            obj = JSON.parse(a)
          }
          tableData[index] = { ...element, ...obj }
          console.log('element', tableData[index])
        })
        console.log('@@->table', tableData)
        this.tableData = tableData
      }
    },
    //添加已发行产品情况
    reloadData() {
      this.getProductListData()
    },
    //查看详情
    lookDetail(codeId, isFundShow) {
      this.fundId = codeId
      this.isBackShow = isFundShow
      // isFundShow === true ? this.tableConf = step5 : this.tableConf = step2;
      this.getMessageList()
    },
    //返回列表
    backList() {
      this.isBackShow = false
      //this.tableConf = step2;
      // this.fundId = '';
      this.getProductListData()
    },
    handleSelectionChange(ids) {
      this.selectIds = ids
    },

    async delProduct() {
      if (!this.selectIds) {
        this.$message({
          message: '请先选择删除的列表,再点击删除!',
          type: 'warning'
        })
        return
      }
      if (this.isManager) {
        await deleteMgrProduct(this.selectIds)
      } else {
        await deleteFundInvested(this.selectIds)
      }
      this.$message({
        message: '删除成功!',
        type: 'success'
      })
      this.reloadData()
    },

    async save() {
      return true
    },

    setEnvironment() {
      this.fillType = this.$store.state.ReportData.reportFillType
      console.log('当前的配置getFillType using', this.fillType)
      if (this.fillType == 'x') {
        this.isManager = true
      }
      if (this.fillType == 'y') {
        this.isManager = false
      }
    },

    setConf() {
      if (this.isManager) {
        console.log('设置的是MGR', step2)
        this.tableConf = step2
      } else {
        console.log('设置的是Agency', step2Agency)
        this.tableConf = step2Agency
        this.lookShow = false
      }
    },

    addDialog(val) {
      this.commonData = {}
      this.title = this.isManager ? '添加机构' : '添加资金投向情况'
      this.$set(this.commonData, 'dte', new Date())
      this.key++
      this.dialogVisible = true
      this.cityList = []
    },

    editTable(val) {
      this.title = this.isManager ? '编辑机构' : '编辑资金投向情况'

      this.commonData = { ...val.scope.row }
      console.log('row的值:', this.commonData)
      this.$set(this.commonData, 'dte', new Date())
      // this.key++
      this.dialogVisible = true
    },

    closeDialog() {
      this.dialogVisible = false
    },
    async getData() {
      const res = await getReportDetail(this.codeId)

      this.setReportData({
        codeId: this.codeId,
        value: res.result
      })
      this.tableData = res.result.product
    },

    setData() {
      if (!this.reportData[this.codeId]) {
        this.getData()
        return
      }
      this.tableData = this.reportData[this.codeId].product
    },
    async getSelect() {
      const query = '5'
      const result = await selectDic(query)
      const {
        //FUND_INSTITUTION_ORIGIN,
        //FUND_PRODUCT_TYPE,
        INVEST_INDUSTRY
      } = result.result

      //this.converSelect(FUND_INSTITUTION_ORIGIN, 11);
      //this.converSelect(FUND_PRODUCT_TYPE, 3);
      if (this.isManager) {
        this.converSelect(INVEST_INDUSTRY, 9)
      } else {
        this.converSelect(INVEST_INDUSTRY, 12)
      }
    },

    async getNation() {
      const query = 0
      const result = await nation(query)
      this.provinceList = result.result
      result.result.forEach(item => {
        let data = {
          label: item.district,
          value: item.district
        }
        if (this.isManager) {
          this.tableConf[6].options.push(data)
        } else {
          this.tableConf[1].options.push(data)
        }
      })
    },

    converSelect(option, index) {
      console.log('%%%%->', this.tableConf)
      option.forEach(item => {
        let data = {
          label: item,
          value: item
        }
        this.tableConf[index].options.push(data)
      })
    },

    inputChange(val) {
      if (val.key === 'registeProvince' || val.key === 'investProvince') {
        this.provinceList.forEach(item => {
          if (item.district === val.value) {
            if (this.isManager) {
              this.tableConf[7].options = []
              this.tableConf[8].options = []
              this.setCityList(item.id)
            } else {
              this.tableConf[2].options = []
              this.tableConf[3].options = []
              this.setCityList(item.id)
            }
          }
        })
      }
      if (val.key === 'registeCity' || val.key === 'investCity') {
        setTimeout(() => {
          console.log('获取地区信息', val, '\ncityList', this.cityList)
          this.cityList.forEach(item => {
            console.log(item, val)
            if (item.district === val.value) {
              if (this.isManager) {
                this.tableConf[8].options = []
                this.setDistrictList(item.id)
              } else {
                this.tableConf[3].options = []
                this.setDistrictList(item.id)
              }
            }
          })
        }, 1000)
      }
    },
    async setCityList(id) {
      const result = await nation(id)
      this.cityList = result.result

      result.result.forEach(item => {
        let data = {
          label: item.district,
          value: item.district
        }
        if (this.isManager) {
          this.tableConf[7].options.push(data) //市区
        } else {
          this.tableConf[2].options.push(data) //市区
        }
      })
    },
    async setDistrictList(id) {
      console.log('根据城市赋值地区')
      const result = await nation(id)

      result.result.forEach(item => {
        let data = {
          label: item.district,
          value: item.district
        }
        if (this.isManager) {
          this.tableConf[8].options.push(data) //地区
        } else {
          this.tableConf[3].options.push(data) //地区
        }
      })
    },
    ...mapMutations(['setReportData'])
  },

  computed: {
    ...mapState({
      reportData(state) {
        return state.ReportData.reportData
      }
    })
  },

  watch: {
    // reportData: {
    //   handler(newValue) {
    //     if (!this.reportData[codeId]) {
    //     }
    //   },
    //   deep: true
    // }
  }
}
</script>

<style scope lang="scss">
::v-deep .table-item:first-child {
  .userInfo::before {
    display: none;
  }
}
</style>
